import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import React from 'react'

export type UserCategoryType = 'standard' | 'trial' | 'inhouse'

export const UserCategorySelect = ({
    onChange,
    value = '',
}: {
    onChange: (val: UserCategoryType) => void
    value: UserCategoryType | ''
}) => {
    return (
        <>
            <InputLabel id='user-category-label'>Kategori</InputLabel>
            <Select<UserCategoryType>
                labelId='user-category-label'
                id='user-category-select'
                name='userCategory'
                value={value}
                onChange={(e) => {
                    onChange(e.target.value as UserCategoryType)
                }}
                label='Kategori'
            >
                <MenuItem value='standard'>Betalande</MenuItem>
                <MenuItem value='trial'>Testkund</MenuItem>
                <MenuItem value='inhouse'>Finance Lab</MenuItem>
            </Select>
        </>
    )
}
